import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsInlineMessageComponent } from "./ds-inline-message.component";
import { PipeModule } from "@nexu-library/utilities";
import { RouterModule } from "@angular/router";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsInlineMessageComponent],
  imports: [CommonModule, PipeModule, RouterModule, DsIconModule],
  exports: [DsInlineMessageComponent],
})
export class DsInlineMessageModule {}
